<template>
    <b-card
      :header="info.platform | getPlatformName"
      no-body
    >
      <b-card-body>
        <form
          :id="formId"
          v-if="mayChangeClientMinVersion"
          @submit.prevent="updateNewMinVersion"
        >
          <div class="form-group mb-0">
            <label for="version-min-new">Min: <b style="color:red">{{info.minVersion}}</b>. Set new (up to {{versionMax}}):</label>
            <input id="version-min-new" ref="minVersionInput" class="form-control" v-model="newMinVersion" required>
            <br>
            <label for="version-recommended-new">Recommended:  <b style="color:orange">{{info.recommendedVersion}}</b>. Set new (up to {{versionMax}}):</label>
            <input id="version-recommended-new" ref="recommendedVersionInput" class="form-control" v-model="newRecommendedVersion" required>
          </div>
        </form>
      </b-card-body>
      <b-card-footer
        v-if="mayChangeClientMinVersion"
      >
        <b-button
          type="submit"
          :form="formId"
          variant="danger"
        >
          Enforce
        </b-button>
      </b-card-footer>
    </b-card>
</template>

<script>
import auth from '../auth';
import { mayChangeClientMinVersion as utilMayChangeClientMinVersion } from '../util';

export default {
  name: 'SystemClientMinVersionOnPlatform',

  props: {
    versionMax: {
      type: String,
      required: true,
    },

    info: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      actor: auth.getViewer(),

      newMinVersion: this.info.minVersion,
      newRecommendedVersion: this.info.recommendedVersion,
    };
  },

  watch: {
    'info.minVersion': function(v) {
      this.newMinVersion = v;
    },
    'info.recommendedVersion': function(v) {
      this.newRecommendedVersion = v;
    },
  },

  computed: {
    mayChangeClientMinVersion() {
      return utilMayChangeClientMinVersion(this.actor.role);
    },

    formId() {
      return 'min-version-form-' + this.info.platform;
    },
  },

  methods: {
    updateNewMinVersion() {
      this.$emit('platform-min-version-update-requested', this.info.platform, this.newMinVersion.trim(), this.newRecommendedVersion.trim(), this);
    },

    focus() {
      this.$refs.minVersionInput.focus();
    },
  },
};
</script>
